












































































import Vue from 'vue'
import Cookies from 'js-cookie'
import Searchbar from '@/components/search/Searchbar.vue'
import SearchResults from '@/views/admin/search/SearchResults.vue'
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter

interface Data {
  hasError: boolean
  hasDatabaseError: boolean
  programOrSkill: string
  searchType: string
  cityOrZip: string
  distance: string
}
interface Methods {
  updateHasError: (hasError: boolean) => void
  handleSearchByProgramOrSkill: (query: string, queryType: string) => void
  setSearchLocation: (location: string) => void
  doSearch: () => void
}
interface Computed {}
interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  data: () => ({
    hasError: false,
    hasDatabaseError: false,
    programOrSkill: '',
    searchType: '',
    cityOrZip: '',
    distance: ''
  }),
  methods: {
    updateHasError: function (hasError: boolean) {
      this.hasError = hasError
    },
    handleSearchByProgramOrSkill: function (query: string, searchType: string) {
      this.programOrSkill = query
      this.searchType = searchType
      if (this.cityOrZip) {
        this.setSearchLocation(this.cityOrZip)
        this.programOrSkill = query
        this.doSearch()
      } else {
        this.hasError = true
      }
    },
    setSearchLocation: function (location: string) {
      Cookies.set('location', location, { expires: 365 })
    },
    doSearch: async function () {
      this.hasError = false
      if (this.cityOrZip && this.programOrSkill && this.searchType) {
        await this.$router.push({
          name: 'Search Results',
          query: {
            location: this.cityOrZip,
            program: this.programOrSkill,
            searchType: this.searchType
          }
        }).catch(failure => {
          if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
            // executes search if already on Search Results page, even if search parameters were not changed
            // this is used when there is a database error and the user clicks to try the search again
            if (this.$route.name === 'Search Results') {
              (this.$refs.view as typeof SearchResults & Vue & { executeSearch: () => void }).executeSearch()
            }
          }
        })
      } else {
        if (!this.cityOrZip) {
          this.hasError = true
        }
      }
    }
  },
  beforeMount: function () {
    const programQuery = this.$route.query.program as string || null
    if (programQuery !== null) {
      this.programOrSkill = programQuery
    }

    const searchTypeQuery = this.$route.query.searchType as string || null
    if (searchTypeQuery !== null) {
      this.searchType = searchTypeQuery
    }

    const locationQuery = this.$route.query.location as string || null
    if (locationQuery !== null) {
      this.cityOrZip = locationQuery
      this.setSearchLocation(locationQuery)
    } else {
      let cookie = Cookies.get('location')
      if (typeof (cookie) !== 'undefined') {
        this.cityOrZip = cookie
      }
    }
  },
  components: {
    Searchbar
  }
})
